import { render, staticRenderFns } from "./resumo-habilitacao-juridica.vue?vue&type=template&id=17e9d6bc&scoped=true"
import script from "./resumo-habilitacao-juridica.vue?vue&type=script&lang=js"
export * from "./resumo-habilitacao-juridica.vue?vue&type=script&lang=js"
import style0 from "./resumo-habilitacao-juridica.vue?vue&type=style&index=0&id=17e9d6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e9d6bc",
  null
  
)

export default component.exports